export const RedirectURL = (url) => {
  const splitURL = url.split('.')[1];
  
  switch(splitURL) {
    case undefined:
      return 'localhost:3000';
    case 'testing':
      return 'https://portoadmin.testing.sambalms.com.br';
    case 'staging':
      return 'http://portoadmin.staging.sambalms.com.br';
    default:
      return 'https://admportoseguro.sambalms.com.br';
  };
};



// WEBPACK FOOTER //
// ./src/variables/RedirectURL.js